interface ErrorProps {
    errorMessage: string;
}

export default function ErrorBlock({ errorMessage }: ErrorProps): JSX.Element {
    return (
        <div id="notfound">
            <div className="notfound">
                <div>
                    <div className="notfound-404">
                        <h1>!</h1>
                    </div>
                    <h2>{errorMessage}</h2>
                </div>
            </div>
        </div>
    );
}
